import React, {useState, useEffect, useMemo, useRef} from 'react'
import { getMyToken, requireRefresh } from '../config/firebaseConfig';

import { onSnapshot, query, where, collection, doc, updateDoc , limit } from "firebase/firestore";
import {db} from '../config/firebaseConfig'
import { useDispatch, useSelector } from 'react-redux';
import axios from '../api/axios';
import { JOB_SNAPSHOT_URL } from '../api/ApiUrl';
import { addTask, deleteTask, updateTaskStatus } from '../features/Tasks';

import { auth } from '../config/firebaseConfig';

import { onAuthStateChanged } from 'firebase/auth';


const Notifications = ({getCompany, getCategories, getAllJobs}) => {
    const [isTokenFound,setTokenFound]=useState(false);
   
    const user=useSelector((state)=>state.user.value);
    const tasks=useSelector((state)=>state.allTasks.value);
    const taskList=useMemo(()=>Array.isArray(tasks) ? tasks : [], [tasks]);
    const taskListRef=useRef(taskList);
    const dispatch=useDispatch();
    const [uid, setUid]=useState(null);



    useEffect(()=>{
      let data;
      async function tokenFound(){
          data= await getMyToken(setTokenFound)
          return data
      }
      tokenFound()

  },[setTokenFound])

useEffect(()=>{
  taskListRef.current=taskList;
},[taskList])


useEffect(()=>{

 const authChecker= onAuthStateChanged(auth, (user) => {
    if (user) {
      
      const uid = user.uid;
      setUid(uid)
    } else {
      setUid(null)
    }
  });

  return()=>{
    authChecker()
  }
},[])

      useEffect(()=>{
        const listenUserState = onSnapshot(doc(db, "UserState", `${user.id}`), (doc) => {
          if(!doc.exists()){
            return;
          }
          const uState=doc.data();
          const shouldRefresh=uState.status==1 && (uState.updateTask || uState.updateCategory || uState.updateComp);
          if(!shouldRefresh){
            return;
          }

          const patchTaskFromSignal=async(signal)=>{
            try{
              if(!signal?.taskId){
                await getAllJobs();
                return;
              }

              if(signal.action==='deleted'){
                dispatch(deleteTask({reference:signal.referenceId, taskId:signal.taskId}));
                return;
              }

              const res=await axios.get(`${JOB_SNAPSHOT_URL}${signal.taskId}`);
              const updatedTask=res.data.task;
              if(!updatedTask){
                return;
              }

              if(signal.action==='created' && res.data.group){
                const groupExists=taskListRef.current.some((group)=>group.referenceId===res.data.group.referenceId);
                if(groupExists){
                  dispatch(updateTaskStatus({
                    reference:res.data.group.referenceId,
                    task:res.data.group.jobs,
                    multiple:true,
                    preserveOrder:true,
                  }));
                }else if(
                  window.location.pathname===`/company/${signal.companyId}` ||
                  window.location.pathname.startsWith(`/category/${signal.companyId}/${signal.categoryId}`)
                ){
                  dispatch(addTask(res.data.group));
                }
                return;
              }

              dispatch(updateTaskStatus({
                reference:updatedTask.referenceId,
                task:updatedTask,
                preserveOrder:true,
              }));
            }catch(error){
              console.warn('Task realtime patch failed', error);
            }
          }

          const refreshJobs=[];
          if(uState.updateTask==true){
            refreshJobs.push(patchTaskFromSignal(uState.taskSignal));
          }
          if(uState.updateCategory==true){
            refreshJobs.push(getCategories());
          }
          if(uState.updateComp==true){
            refreshJobs.push(getCompany());
          }

          Promise.allSettled(refreshJobs).finally(()=>{
            requireRefresh(user.id, false, false, false, null);
          });
      });

      return ()=>{
        listenUserState()
      }
      },[dispatch, getAllJobs, getCategories, getCompany, user.id])


        useEffect(()=>{
         
          const q = query(collection(db, "Notifications"), where("receiverId", "==", user.id), where("delivered","==", false), limit(5));

          const listenNotification=onSnapshot(q, (querySnapshot)=>{
            querySnapshot.forEach((doc) => {
                      const data=doc.data();
                      if(Notification.permission==='granted'){
                        if(data.delivered==false){
                            showNotification(data.title, data.body, data.onClickLink)
                        }
                          
                      }
                      else if(Notification.permission==='denied'){
                        Notification.requestPermission().then(permission=>{
                          if(permission==='granted'){
                            if(data.delivered==false){
                              showNotification(data.title, data.body, data.onClickLink)
                            }
                          }
                        })
                      }
                    readNotification(doc.id)
              })
              

            });

          return () => {
            listenNotification()
           
          }

        },[uid, user.id])


        

      const showNotification=(title, body, link)=>{
        const notification=new Notification(title,{
          body:body,
          icon:'/logo512.png'
        })
        notification.onclick=(e)=>{
          window.location.href=link
        }
       
      }

      const readNotification=async(id)=>{
        const notifyDoc = doc(db, "Notifications", id);
        await updateDoc(notifyDoc, {
          delivered: true
        });
      }




  return (
    <></>
  )
}

export default Notifications
